<!--<div istag="periods">-->
<div istag="pi" *ngFor="let period of periods; let i = index" (click)="selectPeriod($event, period)">
  {{ period.number }}
</div>
<!--</div>-->
